import { Card, Group, Text } from '@mantine/core';
import { InfoIcon } from 'components/InfoIcon';
import { ReactNode } from 'react';

interface InfoCardProps {
  title: string;
  tooltip: string;
  onClick?: () => void;
  children: ReactNode;
  testId: string;
}

export const InfoCard = ({ title, tooltip, onClick, children, testId }: InfoCardProps) => {
  return (
    <Card h={'100%'} shadow={'sm'} radius={'md'} style={{ cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
      <Card.Section withBorder inheritPadding py={'xs'}>
        <Group justify={'space-between'}>
          <Text w={'85%'} fw={500} data-testid={`card-title-${testId}`}>
            {title}
          </Text>
          {tooltip && <InfoIcon i18nKey={tooltip} w={350} testId={`card-info-${testId}`} />}
        </Group>
      </Card.Section>
      {children}
    </Card>
  );
};
